import { Modal } from 'ComponentLibrary/src/piazza/modals/Modal'
import { Typography } from 'ComponentLibrary/src/piazza'
import { noop } from 'lodash'

type Props = {
    open: boolean
    onConfirm: () => void
    onCancel?: () => void
    title: string
    dialogContent?: string | null
    destructive?: boolean
    confirmLabel?: string
    cancelLabel?: string
    isPending?: boolean
}

export default function ConfirmationDialog({
    open,
    onConfirm,
    onCancel,
    title,
    dialogContent = null,
    destructive = false,
    confirmLabel = 'OK',
    cancelLabel = 'Abbrechen',
    isPending,
}: Props) {
    return (
        <Modal
            title={title}
            isOpen={open}
            onClose={onCancel ?? noop}
            disableBackdropClose
            showLoading={isPending}
            footerProps={{
                primaryButton: {
                    text: confirmLabel,
                    onClick: onConfirm,
                    destructive,
                    disabled: isPending,
                },
                secondaryButton: onCancel ? { text: cancelLabel, onClick: onCancel } : undefined,
            }}
        >
            {dialogContent ? <Typography variant="textM">{dialogContent}</Typography> : null}
        </Modal>
    )
}
